import styled from 'styled-components';
import { MD_FONT_SIZE, PRIMARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, SM_PADDING } from '../Common/StyleElement';

export const DropzoneMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #4aa1f3;
    font-size: ${SM_FONT_SIZE};
`

export const Dropzone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 200px;
  width: 100%;
  border: 4px ${props => props.active ? `solid` : `dashed`} ${PRIMARY_COLOR};
  border-radius: 20px;
  transition: 0.3s;
  ${props => props.active ? `background-color: #e8f7fe;` : ``}

  &:hover {
      background-color: #e8f7fe;
  }
  &:active ${DropzoneMessage} {
    transform: scale(0.97);
  }
`

export const DropzoneInput = styled.input`
    display: none;
`

export const DropzoneTitle = styled.div`
    display: inline-flex;
    font-size: ${MD_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    padding-bottom: ${SM_PADDING};
`